import { Box, Card, CardContent, Skeleton, Grid2 } from '@mui/material';

interface DashboardSkeletonProps {
	variant?: 'kpi' | 'chart' | 'table' | 'pie';
	height?: number;
}

export function DashboardSkeleton({ variant = 'chart', height = 400 }: DashboardSkeletonProps) {
	if (variant === 'kpi') {
		return (
			<Card>
				<CardContent>
					<Skeleton variant="text" width="60%" height={30} sx={{ mb: 1 }} />
					<Skeleton variant="text" width="40%" height={48} />
				</CardContent>
			</Card>
		);
	}

	if (variant === 'table') {
		return (
			<Card>
				<CardContent>
					<Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
					{[...Array(5)].map((_, i) => (
						<Skeleton key={i} variant="rectangular" height={40} sx={{ mb: 1 }} />
					))}
				</CardContent>
			</Card>
		);
	}

	if (variant === 'pie') {
		return (
			<Card>
				<CardContent>
					<Box display="flex" justifyContent="center" alignItems="center" height={height}>
						<Skeleton variant="circular" width={height * 0.6} height={height * 0.6} />
					</Box>
				</CardContent>
			</Card>
		);
	}

	return (
		<Card>
			<CardContent>
				<Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
				<Skeleton variant="rectangular" width="100%" height={height - 80} animation="wave" />
			</CardContent>
		</Card>
	);
}

export function KPISkeleton() {
	return (
		<Grid2 container spacing={3} sx={{ mb: 4 }}>
			{[...Array(4)].map((_, i) => (
				<Grid2 key={i} size={{ xs: 12, sm: 6, md: 3 }}>
					<DashboardSkeleton variant="kpi" />
				</Grid2>
			))}
		</Grid2>
	);
}
